var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkspaceswitcher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12294_16764",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0231934,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12294_16764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.52086 10.4142H2.16699C2.02511 10.4142 1.90631 10.3663 1.81059 10.2706C1.71486 10.1749 1.66699 10.0561 1.66699 9.9142C1.66699 9.77232 1.71486 9.65352 1.81059 9.5578C1.90631 9.46208 2.02511 9.41422 2.16699 9.41422H6.52086L4.98238 7.87574C4.89006 7.78342 4.84284 7.66911 4.84071 7.53279C4.83856 7.39646 4.88579 7.2766 4.98238 7.17319C5.08579 7.06977 5.20459 7.01807 5.33878 7.01807C5.47295 7.01807 5.59175 7.06977 5.69518 7.17319L8.01439 9.49242C8.07679 9.55481 8.12081 9.62062 8.14644 9.68985C8.17209 9.75907 8.18491 9.83386 8.18491 9.9142C8.18491 9.99455 8.17209 10.0693 8.14644 10.1386C8.12081 10.2078 8.07679 10.2736 8.01439 10.336L5.68491 12.6655C5.58578 12.7646 5.46975 12.8135 5.33684 12.8123C5.20394 12.811 5.08579 12.7586 4.98238 12.6552C4.88579 12.5518 4.83579 12.4347 4.83238 12.304C4.82895 12.1732 4.87895 12.0561 4.98238 11.9527L6.52086 10.4142ZM9.47976 6.62575L11.0182 8.16424C11.1106 8.25654 11.1578 8.37085 11.1599 8.50717C11.1621 8.64349 11.1148 8.76336 11.0182 8.86677C10.9148 8.97019 10.796 9.0219 10.6618 9.0219C10.5277 9.0219 10.4089 8.97019 10.3054 8.86677L7.98623 6.54755C7.92383 6.48515 7.87981 6.41934 7.85418 6.35012C7.82853 6.28089 7.81571 6.2061 7.81571 6.12575C7.81571 6.04542 7.82853 5.97064 7.85418 5.9014C7.87981 5.83217 7.92383 5.76636 7.98623 5.70397L10.3157 3.37449C10.4148 3.27534 10.5309 3.22641 10.6638 3.22769C10.7967 3.22897 10.9148 3.28132 11.0182 3.38474C11.1148 3.48816 11.1648 3.60525 11.1682 3.73602C11.1717 3.86679 11.1217 3.98387 11.0182 4.08729L9.47976 5.62577H13.8336C13.9755 5.62577 14.0943 5.67363 14.19 5.76935C14.2858 5.86507 14.3336 5.98387 14.3336 6.12575C14.3336 6.26763 14.2858 6.38643 14.19 6.48215C14.0943 6.57789 13.9755 6.62575 13.8336 6.62575H9.47976Z",
    fill: "#FD9567"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceswitcher);
export default __webpack_public_path__ + "static/media/Workspace switcher.d238f2ab7c483c57079e23f0bbfff9ed.svg";
export { ForwardRef as ReactComponent };